import React from "react";
import { useParams } from "react-router-dom";
import { GetSinglePost } from "../../hooks/usePost";

const SinglePost = () => {
  const { id } = useParams();
  const { error, loading, data } = GetSinglePost(id);
  if (error) return (
    <p className=" text-center mt-5 text-6xl font-extrabold text-lime-500 ">{`${error.message}`}</p>
  );
  if (loading)
    return (
      <p className=" text-center mt-5 text-6xl font-extrabold text-lime-500 ">
        Loading...
      </p>
    );
  if (data)
    return (
      <div className="">
        {
          <div className=" justify-between text-center ">
            <h2 className="text-2xl mx-3 uppercase font-semibold mt-5  ">
              {data?.blog_posts[0]?.category}
            </h2>
            <h2 className="mx-3 text-lg font-semibold mt-5  text-zinc-800 ">
              {data?.blog_posts[0]?.title}
            </h2>
            <h2 className="mx-3 mt-5 w-auto px-20  text-center  h-full break-words   ">
              {data?.blog_posts[0]?.content}
            </h2>
            <h2 className="mx-3 overflow-hidden text-lime-400">
              {data?.blog_posts[0]?.author_id}
            </h2>
          </div>
        }
      </div>
    );
};

export default SinglePost;
